var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"news-title-layout"},[_c('div',{staticClass:"news-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"news-title-desc"},[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []

export { render, staticRenderFns }